import { createElement, formatUnit, remove, SanitizeHtmlHelper } from '@syncfusion/ej2-base';
import * as cls from '../base/css-constants';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export class NonWorkingDay {
    constructor(gantt) {
        this.weekendWidthUpdated = false;
        this.parent = gantt;
        this.nonworkingContainer = null;
        this.holidayContainer = null;
        this.weekendContainer = null;
    }
    /**
     * Method append nonworking container
     *
     * @returns {void} .
     */
    createNonworkingContainer() {
        if (!this.parent.ganttChartModule.chartBodyContent.contains(this.nonworkingContainer)) {
            this.nonworkingContainer = createElement('div', {
                className: cls.nonworkingContainer
            });
            if (this.parent.enableTimelineVirtualization) {
                this.nonworkingContainer.style.height = '100%';
            }
            this.parent.ganttChartModule.chartBodyContent.insertBefore(this.nonworkingContainer, this.parent.ganttChartModule.chartBodyContent.firstChild);
        }
    }
    /**
     * calculation for holidays rendering.
     *
     * @returns {void} .
     * @private
     */
    renderHolidays() {
        const holidays = this.parent.calendarModule.holidays;
        if (holidays && holidays.length > 0) {
            this.createNonworkingContainer();
            if (!this.nonworkingContainer.contains(this.holidayContainer)) {
                this.holidayContainer = createElement('div', {
                    className: cls.holidayContainer
                });
                if (this.parent.enableTimelineVirtualization) {
                    this.holidayContainer.style.height = '100%';
                    this.holidayContainer.style.zIndex = '-1';
                }
                this.nonworkingContainer.appendChild(this.holidayContainer);
            }
            const holidayElements = this.getHolidaysElement().childNodes;
            this.holidayContainer.innerHTML = '';
            holidayElements.forEach((element) => {
                this.holidayContainer.appendChild(element.cloneNode(true));
            });
        }
        else if (this.holidayContainer && this.holidayContainer.parentNode) {
            remove(this.holidayContainer);
            if (this.nonworkingContainer && this.nonworkingContainer.childNodes.length === 0) {
                remove(this.nonworkingContainer);
            }
        }
    }
    /**
     * Method to return holidays as html string
     *
     * @returns {HTMLElement} .
     */
    getHolidaysElement() {
        let fromDate;
        let toDate;
        const container = createElement('div');
        const height = this.parent.contentHeight;
        let toolbarHeight = 0;
        const holidays = this.parent.calendarModule.holidays;
        if (!isNullOrUndefined(this.parent.toolbarModule) && !isNullOrUndefined(this.parent.toolbarModule.element)) {
            toolbarHeight = this.parent.toolbarModule.element.offsetHeight;
        }
        const viewportHeight = this.parent.ganttHeight - toolbarHeight - this.parent.ganttChartModule.chartTimelineContainer.offsetHeight;
        for (let i = 0; i < holidays.length; i++) {
            if (holidays[i].from &&
                holidays[i].to) {
                fromDate = this.parent.dateValidationModule.getDateFromFormat(holidays[i].from);
                toDate = this.parent.dateValidationModule.getDateFromFormat(holidays[i].to);
                toDate.setDate(toDate.getDate() + 1);
                fromDate.setHours(0, 0, 0, 0);
                toDate.setHours(0, 0, 0, 0);
            }
            else if (holidays[i].from) {
                fromDate = this.parent.dateValidationModule.getDateFromFormat(holidays[i].from);
                fromDate.setHours(0, 0, 0, 0);
            }
            else if (holidays[i].to) {
                fromDate = this.parent.dateValidationModule.getDateFromFormat(holidays[i].to);
                fromDate.setHours(0, 0, 0, 0);
            }
            const width = (holidays[i].from &&
                holidays[i].to)
                ? this.parent.dataOperation.getTaskWidth(fromDate, toDate)
                : this.parent.perDayWidth;
            const left = this.parent.dataOperation.getTaskLeft(fromDate, false, this.parent.defaultCalendarContext, true);
            const align = this.parent.enableRtl ? `right:${left}px;` : `left:${left}px;`;
            const holidayDiv = createElement('div', {
                className: cls.holidayElement, styles: `${align} width:${width}px; height:100%;`
            });
            const spanTop = (viewportHeight < height) ? viewportHeight / 2 : height / 2;
            const spanElement = createElement('span', {
                className: cls.holidayLabel, styles: `top:${spanTop}px;left:${(width / 2)}px;`
            });
            const property = this.parent.disableHtmlEncode ? 'textContent' : 'innerHTML';
            spanElement[property] = holidays[i].label ? holidays[i].label : '';
            if (this.parent.enableHtmlSanitizer && typeof (spanElement[property]) === 'string') {
                spanElement[property] = SanitizeHtmlHelper.sanitize(spanElement[property]);
            }
            holidayDiv.appendChild(spanElement);
            if (holidays[i].cssClass) {
                holidayDiv.classList.add(holidays[i].cssClass);
            }
            container.appendChild(holidayDiv);
        }
        return container;
    }
    /**
     * @returns {void} .
     * @private
     */
    renderWeekends() {
        if (this.parent.highlightWeekends && this.parent.timelineSettings.showWeekend) {
            this.createNonworkingContainer();
            if (!this.nonworkingContainer.contains(this.weekendContainer)) {
                this.weekendContainer = createElement('div', {
                    className: cls.weekendContainer
                });
                if (this.parent.enableTimelineVirtualization) {
                    this.weekendContainer.style.height = '100%';
                    this.weekendContainer.style.zIndex = '-1';
                }
                this.nonworkingContainer.appendChild(this.weekendContainer);
            }
            const weekendElements = this.getWeekendElements().childNodes;
            this.weekendContainer.innerHTML = '';
            weekendElements.forEach((element) => {
                this.weekendContainer.appendChild(element.cloneNode(true));
            });
        }
        else if (this.weekendContainer) {
            remove(this.weekendContainer);
            this.weekendContainer = null;
            if (this.nonworkingContainer && this.nonworkingContainer.childNodes.length === 0) {
                remove(this.nonworkingContainer);
                this.nonworkingContainer = null;
            }
        }
    }
    /**
     * Method to get weekend html string
     *
     * @returns {HTMLElement} .
     */
    getWeekendElements() {
        const container = createElement('div');
        const leftValueForStartDate = (this.parent.enableTimelineVirtualization &&
            this.parent.ganttChartModule.scrollObject.element.scrollLeft !== 0)
            ? this.parent.ganttChartModule.scrollObject.getTimelineLeft() : null;
        const startDate = (this.parent.enableTimelineVirtualization && !isNullOrUndefined(leftValueForStartDate))
            ? new Date((this.parent.timelineModule['dateByLeftValue'](leftValueForStartDate)).getTime()) :
            new Date(this.parent.timelineModule.timelineStartDate.getTime());
        const endDate = this.parent.enableTimelineVirtualization ? new Date((this.parent.timelineModule.weekendEndDate).getTime()) :
            new Date(this.parent.timelineModule.timelineEndDate.getTime());
        const nonWorkingIndex = this.parent.nonWorkingDayIndex;
        let isFirstCell = true;
        let isFirstExecution = true;
        this.weekendWidthUpdated = false;
        const hasDST = this.parent.dataOperation.hasDSTTransition(startDate.getFullYear());
        do {
            if (nonWorkingIndex.indexOf(startDate.getDay()) !== -1) {
                const left = this.parent.dataOperation.getTaskLeft(startDate, false, this.parent.defaultCalendarContext, true);
                let width = this.parent.perDayWidth;
                if (isFirstCell) {
                    const start = new Date(startDate.getTime());
                    const tempEnd = new Date(start.getTime());
                    tempEnd.setDate(tempEnd.getDate() + 1);
                    tempEnd.setHours(0, 0, 0, 0);
                    width = this.parent.dataOperation.getTaskWidth(start, tempEnd);
                    isFirstCell = false;
                }
                if (!hasDST) {
                    const sDate = new Date(startDate);
                    const dubDate = new Date(startDate);
                    sDate.setDate(sDate.getDate() + 1);
                    const sDateOffset = sDate.getTimezoneOffset();
                    const dubDateOffset = dubDate.getTimezoneOffset();
                    if (!isFirstExecution) {
                        const isHourTimeline = (this.parent.timelineModule.bottomTier === 'Hour' &&
                            this.parent.timelineModule.customTimelineSettings.bottomTier.count === 1) ||
                            (this.parent.timelineModule.bottomTier === 'Minutes' &&
                                this.parent.timelineModule.customTimelineSettings.bottomTier.count === 60) ||
                            (this.parent.timelineModule.topTier === 'Hour' &&
                                this.parent.timelineModule.customTimelineSettings.topTier.count === 1 &&
                                this.parent.timelineModule.bottomTier === 'Minutes' &&
                                (this.parent.timelineModule.customTimelineSettings.bottomTier.count === 30 ||
                                    this.parent.timelineModule.customTimelineSettings.bottomTier.count === 15));
                        if (!this.weekendWidthUpdated) {
                            if (isHourTimeline && sDateOffset < dubDateOffset) {
                                width = width - (this.parent.perDayWidth / 24);
                                this.weekendWidthUpdated = true;
                            }
                        }
                    }
                    else {
                        isFirstExecution = false;
                    }
                }
                const align = this.parent.enableRtl ? `right:${left}px;` : `left:${left}px;`;
                const weekendDiv = createElement('div', {
                    className: cls.weekend, styles: `${align} width:${width}px;height:100%;`
                });
                container.appendChild(weekendDiv);
            }
            startDate.setDate(startDate.getDate() + 1);
            startDate.setHours(0, 0, 0, 0);
        } while (startDate < endDate);
        return container;
    }
    updateHolidayLabelHeight() {
        const height = this.parent.getContentHeight();
        const gantttable = document.getElementById(this.parent.element.id);
        let toolbarHeight = 0;
        if (!isNullOrUndefined(this.parent.toolbarModule) && !isNullOrUndefined(this.parent.toolbarModule.element)) {
            toolbarHeight = this.parent.toolbarModule.element.offsetHeight;
        }
        const viewportHeight = (this.parent.height === 'auto') ? gantttable.offsetHeight - toolbarHeight - this.parent.ganttChartModule.chartTimelineContainer.offsetHeight :
            this.parent.ganttHeight - toolbarHeight - this.parent.ganttChartModule.chartTimelineContainer.offsetHeight;
        const top = (viewportHeight < height) ? viewportHeight / 2 : height / 2;
        const labels = this.holidayContainer.querySelectorAll('.' + cls.holidayLabel);
        for (let i = 0; i < labels.length; i++) {
            labels[i].style.top = formatUnit(top);
        }
    }
    /**
     * Method to update height for all internal containers
     *
     * @returns {void} .
     * @private
     */
    updateContainerHeight() {
        const height = this.parent.getContentHeight();
        if (this.holidayContainer) {
            this.holidayContainer.style.height = formatUnit(height);
            this.updateHolidayLabelHeight();
        }
        if (this.weekendContainer) {
            this.weekendContainer.style.height = formatUnit(height);
        }
    }
    /**
     * Method to remove containers of holiday and weekend
     *
     * @returns {void} .
     */
    removeContainers() {
        if (this.holidayContainer) {
            remove(this.holidayContainer);
        }
        if (this.weekendContainer) {
            remove(this.weekendContainer);
            this.weekendContainer = null;
        }
        if (this.nonworkingContainer) {
            remove(this.nonworkingContainer);
            this.nonworkingContainer = null;
        }
    }
}
